/**
 * @generated SignedSource<<0944c4d992234c1aa8d6cf7cf7334012>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$data = {
  readonly id: string;
  readonly key: string;
  readonly " $fragmentType": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue";
};
export type moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$key = {
  readonly " $data"?: moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "970de75536631065f879841e95abf41b";

export default node;
